import {
    type FC,
    useId
} from "react";
import {
    Animated
} from "react-native";
import type IEdgeFadeProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize
} from "../../../../core/hooks";
import {
    usePresence
} from "../../../../helpers/motion";
import {
    LinearGradient,
    Defs,
    Rect,
    Stop,
    Svg
} from "react-native-svg";

const EdgeFade: FC<IEdgeFadeProps> = ({
    isVisible = true,
    customTheme,
    color,
    edge,
    style
}) => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const {
        isRendered,
        progress
    } = usePresence({
        enterIntent: "hover",
        exitIntent: "hover",
        customTheme,
        isVisible
    });

    const gradientID = useId().replace(/[^a-zA-Z0-9]/g, "");

    const isVertical = edge === "top" || edge === "bottom";

    const isOpaqueAtOrigin = isVertical ? edge === "top" : (edge === "start") === (direction === "ltr");

    if(!isRendered) {
        return null;
    }

    return <Animated.View
        style={[
            style,
            stylesheet.container,
            stylesheet[edge],
            {
                opacity: progress
            }
        ]}
        aria-hidden={true}
    >
        <Svg
            height="100%"
            width="100%"
        >
            <Defs>
                <LinearGradient
                    x2={isVertical ? "0" : "1"}
                    y2={isVertical ? "1" : "0"}
                    id={gradientID}
                    x1="0"
                    y1="0"
                >
                    <Stop
                        stopOpacity={isOpaqueAtOrigin ? 1 : 0}
                        stopColor={color}
                        offset="0"
                    />
                    <Stop
                        stopOpacity={isOpaqueAtOrigin ? 0 : 1}
                        stopColor={color}
                        offset="1"
                    />
                </LinearGradient>
            </Defs>
            <Rect
                fill={`url(#${gradientID})`}
                height="100%"
                width="100%"
            />
        </Svg>
    </Animated.View>;
};
export default EdgeFade;
